import {toast} from 'react-toastify'

export const notifySuccess = ({message, position}) => {
  toast.success(message, {
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    className: 'custom-toast',
  })
}

export const notifyErrorOccured = ({message, position}) => {
  toast.error(message ? message : 'An error occured. Please try again.', {
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    className: 'custom-toast-error',
  })
}

export const notifyWarning = ({message, position}) => {
  toast.warning(message ? message : 'An error occured. Please try again.', {
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'light',
    className: 'custom-toast-warning',
  })
}
